
import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {ProviderSummaryModel} from '../../../common/api/entity/providerSummary.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class ProviderServiceSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    id: number;
    name: string;
    provider: ProviderSummaryModel;
    service: LovValueSummary;

}

export enum Service {
    SERVICE_PODOPRO_APP = 'SERVICE_PODOPRO_APP',
    SERVICE_INSOLE_PRODUCTION = 'SERVICE_INSOLE_PRODUCTION',
    SERVICE_INSOLE_SUBCONTRACTING = 'SERVICE_INSOLE_SUBCONTRACTING',
    SERVICE_INSOLE_SELF_PRODUCTION = 'SERVICE_INSOLE_SELF_PRODUCTION',
    SERVICE_TELETRANSMISSION = 'SERVICE_TELETRANSMISSION',
    SERVICE_MEDICAL_STERILIZATION_APP = 'SERVICE_MEDICAL_STERILIZATION_APP'
}
